export default __webpack_public_path__ + "static/media/ic_armenia.97234d8a.svg";